import { z } from 'zod/v4'

export const favoriteSchema = z
  .object({
    path: z.string(),
    name: z.string(),
    color: z.string().optional(),
    iconName: z.string().optional(),
    // If set, we can get the color and icon from the plugin
    entityType: z.string().optional(),
  })
  .describe('Page name and path')

// Used to support legacy favorites (i.e., entity IDs)
export const favoriteSchemaLegacy = z.union([z.string().describe('Entity ID'), favoriteSchema])

export type Favorite = z.infer<typeof favoriteSchema>
